import React, { useState, useEffect } from 'react';
import { MailIcon, PhoneOutgoingIcon } from '@heroicons/react/outline';
import { isBrowser, isMobile } from 'react-device-detect';


export default function ShareLinks({ product }) {
  const [device, setDevice] = useState('browser');
  const wrapperClasses = `max-w-3xl`;
  const gridClasses =  `sm:grid-cols-2`;

  const { name, league, center } = product;
  const { share_email: shareEmail, share_email_subject: shareEmailSubject, share_text: shareText } = league;


  const defaultMailToSubject = `Check out ${name} on Fun Bowling Leagues`;
  const mailToSubject = shareEmailSubject ? shareEmailSubject : defaultMailToSubject;
  const url = `${process.env.GATSBY_SITE_URL}/${league.slug}/${center.slug}/${product.id}`;
  const defaultMailToBody = `I'm interested in joining the league ${name}.  You should check it out and join too, here's the link: ${url}`;
  const mailToBody = shareEmail ? shareEmail.replace('[link]', url) : defaultMailToBody;
  const smsBody = shareText ? shareText.replace('[link]', url) : defaultMailToBody;
  const mailToUrl = `mailto:?Subject=${mailToSubject}&Body=${mailToBody}`;
  const smsUrl = `sms:&body=${smsBody}`;
  const facebookShareUrl = `https://www.facebook.com/share.php?u=${encodeURIComponent(url)}`;


  useEffect(() => {
    if (isBrowser && device !== 'browser') {
      setDevice('browser');
    } else if (isMobile && device !== 'mobile') {
      setDevice('mobile');
    }
  }, [isBrowser, isMobile, device]);


  return (
    <div className={`${wrapperClasses} mx-auto py-6`}>
      <dl className={`rounded-lg border border-gray-50 bg-white shadow-lg sm:grid ${gridClasses}`}>
        
        {!!facebookShareUrl && (
          <div className="flex flex-col border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r">
          <dt className="order-2 mt-2 leading-6 font-medium text-gray-500"><a href={facebookShareUrl} target="_blank" rel="nofollow">Share With Friends<br />On Facebook!</a></dt>
          <dd className="order-1 text-5xl font-extrabold text-indigo-600">
            <a href={facebookShareUrl} target="_blank" rel="nofollow">
              <svg fill="currentColor" viewBox="0 0 24 24" className="h-16 w-16 mx-auto">
                <path
                  fillRule="evenodd"
                  d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
          </dd>
        </div>
        )}

        <div className="flex flex-col border-t border-b border-gray-100 p-6 text-center sm:border-0 sm:border-l sm:border-r">
          {device === 'browser' && (
            <>
              <dt className="order-2 mt-2 leading-6 font-medium text-gray-500"><a href={mailToUrl}>Email A Few Friends<br />To Join The Fun!</a></dt>
              <dd className="order-1 text-5xl font-extrabold text-indigo-600">
                <a href={mailToUrl}>
                  <MailIcon className="h-16 w-16 mx-auto" />
                </a>
              </dd>
            </>
          )}
          {device === 'mobile' && (
            <>
              <dt className="order-2 mt-2 leading-6 font-medium text-gray-500"><a href={smsUrl}>Text A Few Friends<br />To Join The Fun!</a></dt>
              <dd className="order-1 text-5xl font-extrabold text-indigo-600">
                <a href={smsUrl}>
                  <PhoneOutgoingIcon className="h-16 w-16 mx-auto" />
                </a>
              </dd>
            </>
          )}
        </div>
        
      </dl>
    </div>
  )
}